export const formatAmount = (num = "", separator = ",") => {
  if (num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator) || 0;
  }
  return "";
};

export function convertToUrlString(val) {
  return val?.replaceAll(" ", "-").toLowerCase().replaceAll("'", "");
}

export function convertToUnderscoreString(val) {
  return val?.replaceAll("_", " ").toLowerCase().replaceAll("'", "");
}

export function formatCode(code) {
  const vals = [];
  for (const key in code) {
    vals.push(code[key]);
  }

  return vals.join("");
}

export const formatToSpace = (payload) => {
  if (payload) {
    return payload.replace(/%20/g, " ");
  }
  return payload;
};

export const randomTextGenerator = (payload) => {
  if (payload) return payload[Math.floor(Math.random() * payload?.length)];
};

export const formatCurrency = (val) => {
  return val.toLocaleString("en-NG", { style: "currency", currency: "NGN" });
};

export const formatTime = (val) => {
  if (val < 10) {
    return `0${val}`;
  } else return val;
};

export const timeReform = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, "0")}:${secs
    .toString()
    .padStart(2, "0")}`;
};

export function extractFromPath(pathWithQuery) {
  try {
    const [path, queryString] = pathWithQuery.split("?");
    const pathParts = path.split("/");

    const campaignIdIndex = pathParts.indexOf("campaign_id") + 1;
    const gameIdIndex = pathParts.indexOf("game_id") + 1;

    const campaign_id = pathParts[campaignIdIndex];
    const game_id = pathParts[gameIdIndex];

    if (!campaign_id || !game_id) {
      throw new Error("Missing campaign_id or game_id in the path");
    }

    const queryParams = queryString
      ? new URLSearchParams(queryString)
      : new URLSearchParams();
    const expires = queryParams.get("expires");
    const signature = queryParams.get("signature");

    // Always build query string in the required order
    let query = `?campaign_id=${campaign_id}`;
    if (expires) query += `&expires=${expires}`;
    query += `&game_id=${game_id}`;
    if (signature) query += `&signature=${signature}`;

    return query;
  } catch (error) {
    console.error("Error:", error.message);
    return null;
  }
}

export function extractIdsFromUrl(url) {
  const regex = /campaign_id\/([^/]+)\/game_id\/([^/]+)/;
  const match = url.match(regex);

  if (match) {
    const campaignId = match[1];
    const gameId = match[2];
    return { campaignId, gameId };
  }

  return null;
}

export const extractIdsFromPath = (pathWithQuery) => {
  const [path, queryString] = pathWithQuery.split("?");
  const pathParts = path.split("/");

  console.warn(queryString);

  const campaignIdIndex = pathParts.indexOf("campaign_id") + 1;
  const gameIdIndex = pathParts.indexOf("game_id") + 1;

  const campaign_id = pathParts[campaignIdIndex];
  const game_id = pathParts[gameIdIndex];

  if (campaign_id && game_id) {
    return { campaign_id, game_id };
  }
  return null;
};

export const extractBrandIdFromPath = (pathWithQuery) => {
  const [path] = pathWithQuery.split("?");
  const pathParts = path.split("/");

  const brandIdIndex = pathParts.indexOf("brand_id") + 1;

  const brand_id = pathParts[brandIdIndex];

  if (brand_id) {
    return { brand_id };
  }
  return null;
};

export const ordinalSuffix = (num) => {
  if (num == null || num === 0 || isNaN(Number(num))) {
    return "";
  }
  const j = num % 10,
    k = num % 100;
  if (j === 1 && k !== 11) return num + "st";
  if (j === 2 && k !== 12) return num + "nd";
  if (j === 3 && k !== 13) return num + "rd";
  return num + "th";
};

export const calculateBadgeProgress = (userPoints, currentBadge, nextBadge) => {
  // Ensure we have a current badge (should always be provided by BE)
  if (!currentBadge) {
    return {
      currentBadge: { name: "Novice", points: 0 },
      nextBadge: nextBadge || { name: "No badges available", points: 0 },
      currentPoints: userPoints || 0,
      nextPoints: nextBadge ? nextBadge.points : 0,
      totalUserPoints: userPoints || 0,
      progressPercentage: 0,
    };
  }

  // Handle case where user has achieved all badges (next_badge is null)
  if (!nextBadge) {
    return {
      currentBadge,
      nextBadge: { name: "Max", points: currentBadge.points },
      currentPoints: userPoints || 0, // Show total points
      nextPoints: currentBadge.points, // Show current badge requirement
      totalUserPoints: userPoints || 0,
      progressPercentage: 100, // 100% since they've achieved everything
    };
  }

  // Normal case: user is between current badge and next badge
  const currentPoints = (userPoints || 0) - currentBadge.points;
  const nextPoints = nextBadge.points - currentBadge.points;

  // Calculate progress percentage for the current segment
  const progressPercentage = Math.min(
    Math.max(Math.round((currentPoints / nextPoints) * 100), 0),
    100,
  );

  return {
    currentBadge,
    nextBadge,
    currentPoints: Math.max(currentPoints, 0), // Ensure non-negative
    nextPoints,
    totalUserPoints: userPoints || 0,
    progressPercentage,
  };
};

// Usage example:
// const progress = calculateBadgeProgress(
//   rewardsData.point,
//   rewardsData.current_badge,
//   rewardsData.next_badge
// );

export function formatToNaira(value) {
  const number = Number(value);
  if (isNaN(number)) return "₦0.00";

  return number.toLocaleString("en-NG", {
    style: "currency",
    currency: "NGN",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function getFirstWordCapitalized(slug) {
  // Split the string by underscore and get the first part
  const firstWord = slug.split("_")[0];

  // Capitalize the first letter and keep the rest lowercase
  return firstWord.charAt(0).toUpperCase() + firstWord.slice(1).toLowerCase();
}

export const Capitalize = (str) => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const getValidImageUrl = (imageUrl, fallbackUrl) => {
  if (
    !imageUrl ||
    imageUrl.includes("example.com") ||
    imageUrl.includes("default.png")
  ) {
    return fallbackUrl;
  }
  return imageUrl;
};

export const getInitials = (firstName, lastName) => {
  // Handle cases where one or both names are missing
  if (!firstName && !lastName) return "A";

  if (!firstName) {
    // Only lastName provided
    return lastName.trim().charAt(0).toUpperCase();
  }

  if (!lastName) {
    // Only firstName provided
    return firstName.trim().charAt(0).toUpperCase();
  }

  // Both names provided - take first character of each
  return (firstName.trim().charAt(0) + lastName.trim().charAt(0)).toUpperCase();
};
